var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileMenuBackIcon = function SvgMobileMenuBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m7.554 11.118-4.389-4.4 4.39-4.398L6.202.969l-5.75 5.75 5.75 5.75z"
  })));
};
export { SvgMobileMenuBackIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDggMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNNy41NTQzOCAxMS4xMTc1TDMuMTY1MjEgNi43MTg3NUw3LjU1NDM4IDIuMzJMNi4yMDMxMyAwLjk2ODc1TDAuNDUzMTI1IDYuNzE4NzVMNi4yMDMxMyAxMi40Njg3TDcuNTU0MzggMTEuMTE3NVoiIGZpbGw9IiM4MDgwODAiLz4KPC9zdmc+Cg==";